// extracted by mini-css-extract-plugin
export default {"container":"InGameHeader_container__0SGg4","pad_right":"InGameHeader_pad_right__CWisU"};